import { TAO_KOE } from './../libs';

let timer = null;

const defaults = {
	text: null,
	success: '"%s" copied  successfully!',
	fail: 'Sorry, your Browser does not support this feature. Copy manually!',
};

const copyCouponCode = async function( configData, targetEl ) {
	const config = {
		text: null,
		success: null,
		fail: null,
		...defaults,
		...( typeof configData === 'string' ? { text: configData } : configData ),
	};

	if ( 'clipboard' in navigator ) {
		await navigator.clipboard.writeText( config.text );

		if ( config.success ) {
			const voucherEl = targetEl.closest( '.en_voucher_box' );

			if ( voucherEl ) {
				voucherEl.classList.add( 'is-copied' );

				if ( timer ) {
					clearTimeout( timer );
				}

				timer = setTimeout( function( ) {
					voucherEl.classList.remove( 'is-copied' );
				}, 5000 );
			}
		}
	}
};

const initCouponCode = () => {
	document.body.addEventListener( 'click', async( ev ) => {
		if ( ev.target.closest( '.en_voucher_box' ) ) {
			ev.preventDefault();
		}

		if ( ev.target.closest( '[data-tao-copy]' ) ) {
			ev.preventDefault();
			const configData = ev.target.closest( '[data-tao-copy]' ).dataset.taoCopy || {};
			await copyCouponCode( configData, ev.target );
		}
	} );
};

// Start Coupon Code.
TAO_KOE.ready( 'coupon_code', () => initCouponCode() );

export default copyCouponCode;
